module.exports = __webpack_public_path__ + "static/media/GuestImg.58f71d31.png";